import "./AppTitle.css";

const AppTitle = () => {
  return (
    <div>
      <h1 className="title">Editor de memes</h1>
    </div>
  );
};

export default AppTitle;
